import dice from "./dice";
import slice from "./slice";

export default function(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? slice : dice)(parent, x0, y0, x1, y1);
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-hierarchy/src/treemap/sliceDice.js
// module id = ../../../../d3-hierarchy/src/treemap/sliceDice.js
// module chunks = 4